import AnalyticsAbstract from "@MAIN/modules/Analytics/Abstract";

export default class ECommerce extends AnalyticsAbstract {
  constructor() {
    super()
  }

  detail(product, quantity = 1) {
    this.log('[EC] detail')

    window.dataLayer.push({
      "ecommerce": {
        "detail": {
          "products": [
            {
              "id": product.id,
              "name": product.name,
              "quantity": quantity,
              "price": product.price
            }
          ]
        }
      }
    })
  }

  add({id, name, price}, quantity = 1) {
    this.log('[EC] add')

    window.dataLayer.push({
      "ecommerce": {
        "add": {
          "products": [
            {
              id, name, quantity, price
            }
          ]
        }
      }
    })
  }


  remove(id, name, price, quantity = 1) {
    this.log('[EC] remove')

    window.dataLayer.push({
      "ecommerce": {
        "remove": {
          "products": [
            {
              id, name, quantity, price
            }
          ]
        }
      }
    })
  }


  transaction(order) {
    dataLayer.push({
      "ecommerce": {
        "purchase": {
          "actionField": {
            "id" : order.id,
            "currency": "RUB",
            "revenue": order.total_price,
            "shipping": order.delivery_price,
            "coupon": order.coupon
          },
          "products": order.items
        }
      }
    })

    // [
    //   {
    //     "id": "25341",
    //     "name": "Толстовка Яндекс мужская",
    //     "price": 1345.26,
    //     "brand": "Яндекс / Яndex",
    //     "category": "Одежда/Мужская одежда/Толстовки и свитшоты",
    //     "variant": "Оранжевый цвет"
    //   },
    //     {
    //       "id": "25314",
    //       "name": "Толстовка Яндекс женская",
    //       "price": 1543.62,
    //       "brand": "Яндекс / Яndex",
    //       "category": "Одежда/Женская одежда/Толстовки и свитшоты",
    //       "variant": "Белый цвет",
    //       "quantity": 3
    //     }
    // ]
  }

  begin_checkout() {
    // const params = {
    //   "items": window.CART_FULL.purchases.map(p => {
    //     return {
    //       "id": p.product.id,
    //       "name": p.product.name,
    //       "quantity": p.amount,
    //       "price": p.product.price
    //     }
    //   }),
    //   "coupon": window.CART_FULL.coupon ? window.CART_FULL.coupon.code : null
    // }
    //
    // this.send_gtag_event_UNUSED('begin_checkout', params)
  }

  checkout_progress(checkout_step = 2) {
    // const params = {
    //   "items": window.CART_FULL.purchases.map(p => {
    //     return {
    //       "id": p.product.id,
    //       "name": p.product.name,
    //       "quantity": p.amount,
    //       "price": p.product.price
    //     }
    //   }),
    //   "coupon": window.CART_FULL.coupon ? window.CART_FULL.coupon.code : null,
    //   checkout_step
    // }
    //
    // this.send_gtag_event_UNUSED('checkout_progress', params)
  }


  set_checkout_option(checkout_option, value) {
    // const params = {
    //   "checkout_step": 2,
    //   checkout_option,
    //   value
    // }
    //
    // this.send_gtag_event_UNUSED('set_checkout_option', params)
  }
}
